export default __webpack_public_path__ + "static/media/Adeunis.b4f3e537.png";